import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { default as MaterialCheckbox } from '@material-ui/core/Checkbox';

var styles = function styles(theme) {
  return {
    root: {
      height: '24px',
      width: '24px',
      padding: '0',
      color: theme.palette.secondary.main,
      '&$checked': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: '#CACACA'
      }
    },
    checked: {},
    disabled: {}
  };
};

var Checkbox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  function Checkbox() {
    _classCallCheck(this, Checkbox);

    return _possibleConstructorReturn(this, _getPrototypeOf(Checkbox).apply(this, arguments));
  }

  _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          props = _objectWithoutProperties(_props, ['classes']);

      return React.createElement(MaterialCheckbox, _extends({}, props, {
        classes: _extends({}, classes !== undefined ? classes : {}, {
          root: classes.root,
          checked: classes.checked,
          disabled: classes.disabled
        })
      }));
    }
  }]);

  return Checkbox;
}(React.Component);

Checkbox.propTypes = MaterialCheckbox.propTypes;
export default withStyles(styles)(Checkbox);